var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-sz",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M124.02 0h496.06v496.06H124.02z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-128) scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#3e5eb9",
    d: "M0 0h744.09v496.06H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#ffd900",
    d: "M0 88.583h744.09v318.9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#b10c0c",
    d: "M0 124.02h744.09v248.03H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    rx: 5.238,
    ry: 5.315,
    height: 10.63,
    width: 602.36,
    stroke: "#000",
    y: 242.72,
    x: 74.178,
    strokeWidth: 1.339,
    fill: "#ffd900"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "translate(-609.45 -24.803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-106.3 265.75l-88.583 35.433 88.583 35.433 88.582-35.433-88.582-35.433z",
    fillRule: "evenodd",
    transform: "matrix(.34 0 0 .3 1256.8 136.42)",
    strokeWidth: 3.914,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    rx: 3.851,
    ry: 3.543,
    height: 7.087,
    width: 442.91,
    y: 223.23,
    x: 761.81,
    strokeWidth: 1.25,
    fill: "#ffd900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.4 279.92c-3.54 0-7.09-3.544-7.09-7.087s3.55-7.087 7.09-7.087",
    transform: "matrix(-.50001 0 0 .5 1806.3 90.354)",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.4 279.92c-3.54 0-7.09-3.544-7.09-7.087s3.55-7.087 7.09-7.087",
    transform: "matrix(-.50001 0 0 .5 1802.8 90.354)",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.4 279.92c-3.54 0-7.09-3.544-7.09-7.087s3.55-7.087 7.09-7.087",
    transform: "matrix(-.50001 0 0 .5 1799.2 90.355)",
    strokeWidth: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "translate(-637.8 -3.543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-106.3 265.75l-88.583 35.433 88.583 35.433 88.582-35.433-88.582-35.433z",
    fillRule: "evenodd",
    transform: "matrix(.34 0 0 .3 1256.8 136.42)",
    strokeWidth: 3.914,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    rx: 3.851,
    ry: 3.543,
    height: 7.087,
    width: 442.91,
    y: 223.23,
    x: 761.81,
    strokeWidth: 1.25,
    fill: "#ffd900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.4 279.92c-3.54 0-7.09-3.544-7.09-7.087s3.55-7.087 7.09-7.087",
    transform: "matrix(-.50001 0 0 .5 1806.3 90.354)",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.4 279.92c-3.54 0-7.09-3.544-7.09-7.087s3.55-7.087 7.09-7.087",
    transform: "matrix(-.50001 0 0 .5 1802.8 90.354)",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.4 279.92c-3.54 0-7.09-3.544-7.09-7.087s3.55-7.087 7.09-7.087",
    transform: "matrix(-.50001 0 0 .5 1799.2 90.355)",
    strokeWidth: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.07-.416c-5.571 12.442 4.275-4.138 28.299 16.69 4.452 3.87 8.342 14.09 8.342 21.178-1.13-.975-1.969-3.145-3.214-4.553-1.743 2.253 1.664 12.577 2.162 17.457-3.756-2.71-3.394-3.993-4.642-7.324.249 4.026-.645 15.116.849 19.386-2.96-1.09-2.764-4.163-4.31-4.78 1.052 4.834-.916 10.094-.394 15.528-1.73-2.208-3.573-3.937-4.376-4.829-.135 2.588-3.327 9.388-3.4 11.835-1.468-1.143-1.866-2.926-2.111-4.126-1.824 2.955-8.308 13.872-8.724 17.202-4.996-5.69-17.793-19.545-19.459-26.9-1.473 4.176-3.604 5.584-7.817 8.632-1.665-11.656-7.891-24.756-4.561-34.747-2.359 1.804-4.302 3.608-6.66 5.828 2.234-16.88 13.628-36.674 30.016-46.477z",
    transform: "matrix(.96345 0 0 .74716 308.454 244.121)",
    stroke: "#000",
    fill: "#3d5da7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.141 289.852c2.229-4.454 4.281-5.868 5.721-8.735 2.544-5.041 2.907-9.053 5.123-8.465 2.217.588 2.214 2.653-.657 7.61-2.871 4.957-4.236 6.016-10.187 9.59zm15.075 10.609c-.286-3.391.698-4.807.518-6.992-.306-3.843-1.878-6.48.166-6.669 2.043-.187 2.999 1.124 3.005 4.997.006 3.873-.593 4.89-3.689 8.664zm11.437 6.651c-.893-4.735-.225-6.835-.796-9.885-.995-5.368-2.962-8.9-1.069-9.392 1.894-.49 3.037 1.245 3.754 6.688.718 5.443.339 6.94-1.889 12.589zm11.891-33.178c-2.793-2.12-4.423-2.262-6.224-3.625-3.173-2.39-4.778-4.948-5.798-3.677-1.02 1.27-.296 2.658 3.028 4.863 3.324 2.205 4.45 2.38 8.994 2.439zm-1.969 15.722c-1.472-3.057-3.02-3.832-3.973-5.799-1.683-3.456-1.686-6.446-3.511-5.68-1.826.767-1.973 2.332-.02 5.677 1.952 3.345 2.974 3.95 7.504 5.802z",
    fill: "#a70000"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.6 20.703c-.272-2.662.253-2.98-1.258-4.989 2.2.997 2.284 3.649 4.959 1.767.983-.551 1.411-.569.217-3.526 2.79.14 11.927 3.535 13.39 3.614 3.842.191 10.855-4.373 15.723 1.24 4.672 5.117 3.112 10.428 3.112 17.515-1.877-.975-.973-1.455-2.965-3.989 1.494 6.195-.08 17.364-.08 23.934-.767-1.584-.654-.896-1.404-2.537-1.992 5.997-4.38 7.231-4.38 14.318-.719-2.78-.025-2.191-.825-3.653-1.936 4.552-14.925 8.443-9.92 13.033-4.518-2.87-6.499-2.57-8.548-5.15-.882.617-1.584 1.785-2.404 3.386-7.943-3.96-5.103-12.5-11.326-18.206-1.077 2.393-.586 2.045-1.75 5.939-1.26-5.408-1.604-8.844-3.021-12.82-1.223 2.204-1.113 1.36-3.333 4.69-.918-6.587-2.413-8.142-1.822-12.501-2.359 1.804-.815 1.073-3.173 3.293 2.234-16.88 11.884-29.352 18.808-25.358z",
    transform: "matrix(1.1018 0 0 1.01684 -262.973 231.719)",
    stroke: "#000",
    fill: "#3d5da7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.418 280.784c2.255-5.526 4.287-7.262 5.744-10.819 2.573-6.253 2.992-11.252 5.154-10.49 2.162.763 2.127 3.338-.765 9.483-2.892 6.144-4.246 7.446-10.133 11.826zm8.539 13.826c.904-4.954 2.33-6.759 2.917-9.95 1.04-5.61.46-9.787 2.47-9.568 2.008.22 2.463 2.338 1.126 7.92-1.337 5.58-2.26 6.902-6.513 11.599zm10.211 9.613c.255-4.804 1.38-6.679 1.549-9.772.305-5.442-.743-9.338 1.173-9.36 1.916-.022 2.599 1.935 2.012 7.383-.587 5.447-1.297 6.807-4.734 11.749zm21.93-31.411c-4.193-4.177-6.728-4.957-9.432-7.643-4.765-4.719-7.068-9.148-8.764-7.578-1.696 1.57-.676 3.923 4.34 8.414 5.017 4.49 6.762 5.143 13.856 6.807zm-2.551 16.148c-2.731-4.195-4.735-5.282-6.498-7.98-3.11-4.743-4.178-8.819-5.941-7.81-1.764 1.01-1.37 3.14 2 7.737 3.37 4.596 4.726 5.441 10.44 8.052z",
    fill: "#a70000"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637.8 230.32c-53.15 59.05-124.02 177.16-265.75 177.16-124.02 0-212.6-118.11-265.75-177.16 53.15-59.06 141.73-177.17 265.75-177.17 141.73 0 212.6 118.11 265.75 177.17z",
    transform: "matrix(.66667 0 0 .6 124.02 109.84)",
    stroke: "#000",
    strokeWidth: 1.976,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.688 178.708c9.427 10.603 1.555 14.877 11.533 15.573 10.523.773 4.558 11.203 13.41 11.566 6.188.27-.618 24.99 5.339 33.148 6.068 8.504 11.15 2.492 11.257 8.636.105 6.354-16.516 5.713-16.807 25.287-.487 11.28-14.026 12.003-14.672 19.26-.803 6.828 26.672 10.66 26.306 16.772-.377 6.093-29.667 5.139-30.943 12.088-.654 6.24 40.24 11.356 43.528 29.407-6.102 1.996-23.463 3.875-36.585 3.885-82.674.066-141.734-70.866-177.168-106.296 35.434-35.436 94.487-106.302 177.168-106.302 0 0-24.542 22.424-12.366 36.976z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.03 210.24h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59zm17.178-47.244h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59zm17.178-47.244h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59zm17.183-47.244h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59zm17.178-47.244h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59zm17.178-47.244h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59z",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.95 210.24h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59zm17.178-47.244h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59zm17.178-47.244h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59zm17.183-47.244h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59zm17.178-47.244h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59zm17.178-47.244h8.59v28.346h-8.59zm0 47.244h8.59v28.346h-8.59z",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.07-.416c-5.571 12.442 9.754-4.138 33.778 16.69 4.452 3.87 10.833 19.16 10.833 26.246-5.115-1.257-14.173-7.087-14.173-7.087s10.63 12.295 10.63 26.468c-3.756-2.71-5.635-2.304-6.883-5.634 0 4.588 3.34 7.512 3.34 14.599-2.711-2.498-5.006-4.163-7.3-5.625 3.543 7.086-6.457 20.834-1.452 25.423-8.752-1.462-17.707-7.92-21.25-15.006-1.878 1.462-2.082 3.756-2.155 6.203.276.264-13.322-11.656-12.073-16.235-1.824 2.955-2.081 4.579-2.497 7.909-4.996-5.69-9.574-11.378-11.24-18.733-2.22 3.33-2.359 3.33-4.579 6.66-1.665-11.655-1.665-11.24 1.665-21.23-2.359 1.804-4.302 3.608-6.66 5.828 2.234-16.88 13.628-36.674 30.016-46.477z",
    transform: "matrix(.8811 0 0 .76298 16.874 160.923)",
    stroke: "#000",
    fill: "#3d5da7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.65 206.991c.785-6.542 2.496-9.006 3.006-13.219.912-7.41-.17-12.824 2.456-12.687 2.626.137 3.382 2.87 2.084 10.263s-2.392 9.189-7.546 15.643zm13.705 11.978c-.532-5.52.487-7.87.15-11.424-.584-6.256-2.516-10.494-.228-10.883 2.289-.39 3.446 1.709 3.693 8.025.247 6.316-.365 7.999-3.615 14.282zm21.395 9.771c-2.327-4.775-4.326-6.2-5.828-9.274-2.654-5.402-3.207-9.814-5.253-9.014-2.047.799-1.934 3.081 1.021 8.37 2.955 5.288 4.291 6.366 10.06 9.918zm7.395-42.772c-5.925-3.12-8.969-3.159-12.788-5.163-6.724-3.514-10.638-7.484-12.027-5.3-1.39 2.186.464 4.359 7.397 7.554 6.932 3.195 9.062 3.346 17.418 2.909zm2.175 17.862c-4.315-3.59-6.867-4.118-9.649-6.426-4.902-4.052-7.342-8.03-8.98-6.418-1.637 1.613-.544 3.744 4.602 7.561 5.145 3.817 6.905 4.291 14.027 5.283z",
    fill: "#a70000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/sz.5e362aa32ff77991782cb5d8a60506dc.svg";
export { ForwardRef as ReactComponent };